import EditJobError from './EditJobError';

export default class AddJobError extends EditJobError {
  practice_id: string[] = []
  date: string[] = []
}